import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    min: String,
    max: String
  }

  static targets = ["startDate", "endDate"]

  connect() {}

  input(event) {
    if (event.target === this.startDateTarget && this.hasEndDateTarget) {
      this.updateEndDateMin()
    }
  }

  blur(event) {
    this.enforceConstraintsOnField(event.target)

    if (event.target === this.startDateTarget && this.hasEndDateTarget) {
      this.updateEndDateMin()
    }
  }

  enforceConstraintsOnField(field) {
    if (!field.value) {
      return
    }

    // Avoid enforcing on incomplete input while user is still typing the year
    if (!/^\d{4}-\d{2}-\d{2}$/.test(field.value)) {
      return
    }

    const inputDate = new Date(field.value)

    if (isNaN(inputDate.getTime())) {
      return
    }

    const minAttr = field.getAttribute('min')
    const maxAttr = field.getAttribute('max')

    if (minAttr) {
      const minDate = new Date(minAttr)
      if (inputDate < minDate) {
        field.value = minAttr
      }
    }

    if (maxAttr) {
      const maxDate = new Date(maxAttr)
      if (inputDate > maxDate) {
        field.value = maxAttr
      }
    }
  }

  updateEndDateMin() {
    const startValue = this.startDateTarget.value
    if (!startValue) {
      return
    }

    if (!/^\d{4}-\d{2}-\d{2}$/.test(startValue)) {
      return
    }

    this.endDateTarget.setAttribute('min', startValue)

    if (this.endDateTarget.value && this.endDateTarget.value < startValue) {
      this.endDateTarget.value = startValue
    }
  }
}
